
import React from "react";
import { useState, useEffect  } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo-edbot.png";
import Navbar from "../components/Navbar";


const features = [
  {
    icon: "fas fa-brain text-blue-600",
    title: "Diagnóstico Inteligente",
    desc: "Algoritmo adaptativo que determina tu puntaje proyectado y áreas de mejora."
  },
  {
    icon: "fas fa-stopwatch text-green-600",
    title: "Simulacros Cronometrados",
    desc: "Exámenes estilo UNI con tiempo real y dificultad auténtica."
  },
  {
    icon: "fas fa-chart-pie text-yellow-600",
    title: "Analítica de Rendimiento",
    desc: "Reportes detallados y recomendaciones automáticas para mejorar."
  },
  {
    icon: "fas fa-clipboard-check text-red-600",
    title: "Pruebas de Diagnóstico Gratuitas",
    desc: "Con tu registro puedes rendir pruebas de diagnóstico sin costo."
  },  
  {
    icon: "fas fa-mobile-alt text-purple-600",
    title: "Aprende 24/7",
    desc: "Disponible en todos tus dispositivos para que practiques cuando quieras."
  },
  {
    icon: "fas fa-check-circle text-cyan-600",
    title: "Ejercicios UNI Certificados",
    desc: "Simulacros y pruebas de diagnóstico construidos con ejercicios de nivel UNI verificados por expertos."
  },
];

const testimonials = [
  {
    initials: "AL",
    name: "Andrea L.",
    quote: "Gracias a EDBOT aumenté mi puntaje en más de 150 puntos y me siento listo para el examen real."
  },
  {
    initials: "JM",
    name: "José M.",
    quote: "Los simulacros son idénticos al formato oficial y los reportes de IA me ayudaron a enfocar mi estudio."
  }
];

const Landing = () => {
   // 🔹 Detectar si hay token en localStorage
  const [isAuth, setIsAuth] = useState(() => !!localStorage.getItem("token"));

  useEffect(() => {
    setIsAuth(!!localStorage.getItem("accesstoken"));

    // (opcional) sincronizar entre pestañas
    const handler = () => setIsAuth(!!localStorage.getItem("accesstoken"));
    window.addEventListener("storage", handler);
    return () => window.removeEventListener("storage", handler);
  }, []);
  
  return (
    <div className="antialiased text-gray-800">
      {/* Hero */}
      <Navbar />
      <section className="relative bg-gradient-to-r from-blue-600 to-indigo-700 text-white py-20 md:py-32 rounded-b-xl shadow-xl">
        <div className="container mx-auto px-4 flex flex-col md:flex-row items-center justify-between text-center md:text-left">
          <div className="md:w-1/2 mb-10 md:mb-0">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight mb-4 drop-shadow-lg">
              Libera tu potencial y asegura tu ingreso a la <span className="text-edbot-granate">UNI</span>versidad
            </h1>
            <p className="text-lg md:text-xl mb-8 opacity-90 leading-relaxed">
              EDBOT combina IA, simulacros cronometrados y análisis de datos para llevarte un paso adelante en el examen de admisión.
            </p>
            {/* Aviso de próximo simulacro */}
            <p className="mb-4 text-xl md:text-2x1 font-semibold text-white-300 animate-pulse">
              Próximo simulacro: domingo 27 de julio — 9:00 am
            </p>

            <Link
              to={isAuth ? "/app/diagnostico" : "/login?action=register"}
              className="bg-white text-blue-600 px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-100 shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition inline-block"
            >
              {isAuth ? "Ir al panel" : "Regístrate gratis"} <i className="fas fa-arrow-right ml-2"></i>
            </Link>
            
          </div>

          <div className="md:w-1/2 flex justify-center md:justify-end">
            <img
              src={logo}
              alt="Plataforma EDBOT"
              className="rounded-xl shadow-2xl transform rotate-3 hover:rotate-0 transition duration-500 w-full max-w-lg"
            />
          </div>
        </div>
      </section>

      {/* Features */}
      <section id="features" className="py-16 bg-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12">¿Por qué elegir EDBOT?</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
            {features.map((f, i) => (
              <div key={i} className="p-8 bg-gray-50 rounded-xl shadow-lg border border-gray-100 transform hover:scale-105 transition">
                <div className={`mb-4 text-5xl ${f.icon}`}></div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3">{f.title}</h3>
                <p className="text-gray-600">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section id="testimonios" className="py-16 bg-gradient-to-br from-blue-50 to-indigo-50">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12">Lo que dicen nuestros estudiantes</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
            {testimonials.map((t, i) => (
              <div key={i} className="bg-white p-8 rounded-xl shadow-xl flex flex-col items-center border border-gray-100">
                <div className="rounded-full mb-4 ring-4 ring-blue-300 flex items-center justify-center w-20 h-20 text-white bg-blue-600 text-2xl font-bold">
                  {t.initials}
                </div>
                <p className="text-gray-700 italic mb-4 leading-relaxed">&quot;{t.quote}&quot;</p>
                <p className="font-semibold text-blue-600">- {t.name}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-blue-600 text-white text-center rounded-t-xl shadow-xl">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">¿Listo para empezar?</h2>
          <p className="text-lg md:text-xl mb-8 opacity-90">Únete a miles de estudiantes que ya optimizan su preparación con EDBOT.</p>
          <Link
            to="/login"
            className="bg-white text-blue-600 px-10 py-5 rounded-full font-bold text-xl hover:bg-gray-100 shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition inline-block"
          >
            Regístrate gratis <i className="fas fa-long-arrow-alt-right ml-3"></i>
          </Link>
        </div>
      </section>

      {/* Footer */}
      <footer id="contacto" className="bg-gray-800 text-gray-300 py-12">
        <div className="container mx-auto px-4 grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-white text-xl font-semibold mb-4">ED<span className="text-blue-400">BOT</span></h3>
            <p className="text-sm leading-relaxed">Transformando tu preparación con tecnología y datos.</p>
          </div>
          <div>
            <h3 className="text-white text-lg font-semibold mb-4">Enlaces rápidos</h3>
            <ul className="space-y-2">
              <li><a href="#features" className="hover:text-white transition">Características</a></li>
              <li><a href="#testimonios" className="hover:text-white transition">Testimonios</a></li>
              <li><a href="/privacidad" className="hover:text-white transition">Privacidad</a></li>
              <li><a href="/terminos" className="hover:text-white transition">Términos</a></li>
            </ul>
          </div>
          <div>
            <h3 className="text-white text-lg font-semibold mb-4">Contacto</h3>
            <p className="text-sm mb-2"><i className="fas fa-envelope mr-2"></i> edot.uni@gmail.com</p>
            <p className="text-sm mb-4"><i className="fas fa-phone mr-2"></i> +51 953 373 146</p>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/edbotuni/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white text-xl transition"><i className="fab fa-facebook"></i></a>
              <a href="https://www.youtube.com/@edbotuni" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white text-xl transition"><i className="fab fa-youtube"></i></a>
              <a href="https://www.instagram.com/edbot_uni/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white text-xl transition"><i className="fab fa-instagram"></i></a>
              <a href="https://wa.me/51953373146?text=Hola%20Edbot" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white text-xl transition"><i className="fab fa-whatsapp"></i></a>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-sm">
          &copy; {new Date().getFullYear()} EDBOT. Todos los derechos reservados.
        </div>
      </footer>
    </div>
  );
};

export default Landing;